<template>
  <fragment>
    <v-stepper-step step="1" complete>Application sent</v-stepper-step>
    <v-divider></v-divider>

    <v-stepper-step step="2" :complete="application.seen">
      Application seen
    </v-stepper-step>
    <v-divider v-if="application.rejected"> </v-divider>

    <v-stepper-step step="3" :rules="[() => false]" v-if="application.rejected">
      You have been rejected
    </v-stepper-step>
    <v-divider> </v-divider>

    <v-stepper-step step="3" :complete="application.nextStep">
      Selected for next step
    </v-stepper-step>
  </fragment>
</template>

<script>
export default {
  props: ["application"]
};
</script>

